require("core-js/modules/es6.typed.float64-array");

require("core-js/modules/es6.typed.uint32-array");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.map");

var _require = require('./connectors'),
    Connector = _require.Connector;

var Vertex3D = require('./math/Vertex3');

var Vector2D = require('./math/Vector2');

var Vector3D = require('./math/Vector3');

var Polygon = require('./math/Polygon3');

var _require2 = require('./CSGFactories'),
    fromPolygons = _require2.fromPolygons;

var _require3 = require('./CAGFactories'),
    fromSides = _require3.fromSides,
    fromFakeCSG = _require3.fromFakeCSG;

var canonicalize = require('./utils/canonicalize');

var retesselate = require('./utils/retesellate');

var _require4 = require('./utils/cagValidation'),
    isCAGValid = _require4.isCAGValid,
    _isSelfIntersecting = _require4.isSelfIntersecting,
    _hasPointInside = _require4.hasPointInside;

var _require5 = require('./utils/cagMeasurements'),
    _area = _require5.area,
    _getBounds = _require5.getBounds; // all of these are good candidates for elimination in this scope, since they are part of a functional api


var _require6 = require('../api/ops-cnc'),
    _overCutInsideCorners = _require6.overCutInsideCorners;

var _require7 = require('../api/ops-extrusions'),
    _extrudeInOrthonormalBasis = _require7.extrudeInOrthonormalBasis,
    _extrudeInPlane = _require7.extrudeInPlane,
    _extrude = _require7.extrude,
    _rotateExtrude = _require7.rotateExtrude;

var cagoutlinePaths = require('../api/cagOutlinePaths');

var _center = require('../api/center');

var _require8 = require('../api/ops-expandContract'),
    _expand = _require8.expand,
    _contract = _require8.contract,
    expandedShellOfCAG = _require8.expandedShellOfCAG;
/**
 * Class CAG
 * Holds a solid area geometry like CSG but 2D.
 * Each area consists of a number of sides.
 * Each side is a line between 2 points.
 * @constructor
 */


var CAG = function CAG() {
  this.sides = [];
  this.isCanonicalized = false;
};

CAG.prototype = {
  union: function union(cag) {
    var cags;

    if (cag instanceof Array) {
      cags = cag;
    } else {
      cags = [cag];
    }

    var r = this._toCSGWall(-1, 1);

    r = r.union(cags.map(function (cag) {
      return cag._toCSGWall(-1, 1).reTesselated();
    }), false, false);
    return fromFakeCSG(r).canonicalized();
  },
  subtract: function subtract(cag) {
    var cags;

    if (cag instanceof Array) {
      cags = cag;
    } else {
      cags = [cag];
    }

    var r = this._toCSGWall(-1, 1);

    cags.map(function (cag) {
      r = r.subtractSub(cag._toCSGWall(-1, 1), false, false);
    });
    r = r.reTesselated();
    r = r.canonicalized();
    r = fromFakeCSG(r);
    r = r.canonicalized();
    return r;
  },
  intersect: function intersect(cag) {
    var cags;

    if (cag instanceof Array) {
      cags = cag;
    } else {
      cags = [cag];
    }

    var r = this._toCSGWall(-1, 1);

    cags.map(function (cag) {
      r = r.intersectSub(cag._toCSGWall(-1, 1), false, false);
    });
    r = r.reTesselated();
    r = r.canonicalized();
    r = fromFakeCSG(r);
    r = r.canonicalized();
    return r;
  },
  transform: function transform(matrix4x4) {
    var ismirror = matrix4x4.isMirroring();
    var newsides = this.sides.map(function (side) {
      return side.transform(matrix4x4);
    });
    var result = fromSides(newsides);

    if (ismirror) {
      result = result.flipped();
    }

    return result;
  },
  flipped: function flipped() {
    var newsides = this.sides.map(function (side) {
      return side.flipped();
    });
    newsides.reverse();
    return fromSides(newsides);
  },
  // ALIAS !
  center: function center(axes) {
    return _center({
      axes: axes
    }, [this]);
  },
  // ALIAS !
  expandedShell: function expandedShell(radius, resolution) {
    return expandedShellOfCAG(this, radius, resolution);
  },
  // ALIAS !
  expand: function expand(radius, resolution) {
    return _expand(this, radius, resolution);
  },
  contract: function contract(radius, resolution) {
    return _contract(this, radius, resolution);
  },
  // ALIAS !
  area: function area() {
    return _area(this);
  },
  // ALIAS !
  getBounds: function getBounds() {
    return _getBounds(this);
  },
  // ALIAS !
  isSelfIntersecting: function isSelfIntersecting(debug) {
    return _isSelfIntersecting(this, debug);
  },
  // extrusion: all aliases to simple functions
  extrudeInOrthonormalBasis: function extrudeInOrthonormalBasis(orthonormalbasis, depth, options) {
    return _extrudeInOrthonormalBasis(this, orthonormalbasis, depth, options);
  },
  // ALIAS !
  extrudeInPlane: function extrudeInPlane(axis1, axis2, depth, options) {
    return _extrudeInPlane(this, axis1, axis2, depth, options);
  },
  // ALIAS !
  extrude: function extrude(options) {
    return _extrude(this, options);
  },
  // ALIAS !
  rotateExtrude: function rotateExtrude(options) {
    // FIXME options should be optional
    return _rotateExtrude(this, options);
  },
  // ALIAS !
  check: function check() {
    return isCAGValid(this);
  },
  // ALIAS !
  canonicalized: function canonicalized() {
    return canonicalize(this);
  },
  // ALIAS !
  reTesselated: function reTesselated() {
    return retesselate(this);
  },
  // ALIAS !
  getOutlinePaths: function getOutlinePaths() {
    return cagoutlinePaths(this);
  },
  // ALIAS !
  overCutInsideCorners: function overCutInsideCorners(cutterradius) {
    return _overCutInsideCorners(this, cutterradius);
  },
  // ALIAS !
  hasPointInside: function hasPointInside(point) {
    return _hasPointInside(this, point);
  },
  // All the toXXX functions
  toString: function toString() {
    var result = 'CAG (' + this.sides.length + ' sides):\n';
    this.sides.map(function (side) {
      result += '  ' + side.toString() + '\n';
    });
    return result;
  },
  _toCSGWall: function _toCSGWall(z0, z1) {
    var polygons = this.sides.map(function (side) {
      return side.toPolygon3D(z0, z1);
    });
    return fromPolygons(polygons);
  },
  _toVector3DPairs: function _toVector3DPairs(m) {
    // transform m
    var pairs = this.sides.map(function (side) {
      var p0 = side.vertex0.pos;
      var p1 = side.vertex1.pos;
      return [Vector3D.Create(p0.x, p0.y, 0), Vector3D.Create(p1.x, p1.y, 0)];
    });

    if (typeof m !== 'undefined') {
      pairs = pairs.map(function (pair) {
        return pair.map(function (v) {
          return v.transform(m);
        });
      });
    }

    return pairs;
  },

  /*
    * transform a cag into the polygons of a corresponding 3d plane, positioned per options
    * Accepts a connector for plane positioning, or optionally
    * single translation, axisVector, normalVector arguments
    * (toConnector has precedence over single arguments if provided)
    */
  _toPlanePolygons: function _toPlanePolygons(options) {
    var defaults = {
      flipped: false
    };
    options = Object.assign({}, defaults, options);
    var _options = options,
        flipped = _options.flipped; // reference connector for transformation

    var origin = [0, 0, 0];
    var defaultAxis = [0, 0, 1];
    var defaultNormal = [0, 1, 0];
    var thisConnector = new Connector(origin, defaultAxis, defaultNormal); // translated connector per options

    var translation = options.translation || origin;
    var axisVector = options.axisVector || defaultAxis;
    var normalVector = options.normalVector || defaultNormal; // will override above if options has toConnector

    var toConnector = options.toConnector || new Connector(translation, axisVector, normalVector); // resulting transform

    var m = thisConnector.getTransformationTo(toConnector, false, 0); // create plane as a (partial non-closed) CSG in XY plane

    var bounds = this.getBounds();
    bounds[0] = bounds[0].minus(new Vector2D(1, 1));
    bounds[1] = bounds[1].plus(new Vector2D(1, 1));

    var csgshell = this._toCSGWall(-1, 1);

    var csgplane = fromPolygons([new Polygon([new Vertex3D(new Vector3D(bounds[0].x, bounds[0].y, 0)), new Vertex3D(new Vector3D(bounds[1].x, bounds[0].y, 0)), new Vertex3D(new Vector3D(bounds[1].x, bounds[1].y, 0)), new Vertex3D(new Vector3D(bounds[0].x, bounds[1].y, 0))])]);

    if (flipped) {
      csgplane = csgplane.invert();
    } // intersectSub -> prevent premature retesselate/canonicalize


    csgplane = csgplane.intersectSub(csgshell); // only keep the polygons in the z plane:

    var polys = csgplane.polygons.filter(function (polygon) {
      return Math.abs(polygon.plane.normal.z) > 0.99;
    }); // finally, position the plane per passed transformations

    return polys.map(function (poly) {
      return poly.transform(m);
    });
  },

  /*
    * given 2 connectors, this returns all polygons of a "wall" between 2
    * copies of this cag, positioned in 3d space as "bottom" and
    * "top" plane per connectors toConnector1, and toConnector2, respectively
    */
  _toWallPolygons: function _toWallPolygons(options) {
    // normals are going to be correct as long as toConn2.point - toConn1.point
    // points into cag normal direction (check in caller)
    // arguments: options.toConnector1, options.toConnector2, options.cag
    //     walls go from toConnector1 to toConnector2
    //     optionally, target cag to point to - cag needs to have same number of sides as this!
    var origin = [0, 0, 0];
    var defaultAxis = [0, 0, 1];
    var defaultNormal = [0, 1, 0];
    var thisConnector = new Connector(origin, defaultAxis, defaultNormal); // arguments:

    var toConnector1 = options.toConnector1; // let toConnector2 = new Connector([0, 0, -30], defaultAxis, defaultNormal);

    var toConnector2 = options.toConnector2;

    if (!(toConnector1 instanceof Connector && toConnector2 instanceof Connector)) {
      throw new Error('could not parse Connector arguments toConnector1 or toConnector2');
    }

    if (options.cag) {
      if (options.cag.sides.length !== this.sides.length) {
        throw new Error('target cag needs same sides count as start cag');
      }
    } // target cag is same as this unless specified


    var toCag = options.cag || this;
    var m1 = thisConnector.getTransformationTo(toConnector1, false, 0);
    var m2 = thisConnector.getTransformationTo(toConnector2, false, 0);

    var vps1 = this._toVector3DPairs(m1);

    var vps2 = toCag._toVector3DPairs(m2);

    var polygons = [];
    vps1.forEach(function (vp1, i) {
      polygons.push(new Polygon([new Vertex3D(vps2[i][1]), new Vertex3D(vps2[i][0]), new Vertex3D(vp1[0])]));
      polygons.push(new Polygon([new Vertex3D(vps2[i][1]), new Vertex3D(vp1[0]), new Vertex3D(vp1[1])]));
    });
    return polygons;
  },

  /**
   * Convert to a list of points.
   * @return {points[]} list of points in 2D space
   */
  toPoints: function toPoints() {
    var points = this.sides.map(function (side) {
      var v0 = side.vertex0; // let v1 = side.vertex1

      return v0.pos;
    }); // due to the logic of fromPoints()
    // move the first point to the last

    if (points.length > 0) {
      points.push(points.shift());
    }

    return points;
  },

  /** Convert to compact binary form.
  * See fromCompactBinary.
  * @return {CompactBinary}
  */
  toCompactBinary: function toCompactBinary() {
    var cag = this.canonicalized();
    var numsides = cag.sides.length;
    var vertexmap = {};
    var vertices = [];
    var numvertices = 0;
    var sideVertexIndices = new Uint32Array(2 * numsides);
    var sidevertexindicesindex = 0;
    cag.sides.map(function (side) {
      [side.vertex0, side.vertex1].map(function (v) {
        var vertextag = v.getTag();
        var vertexindex;

        if (!(vertextag in vertexmap)) {
          vertexindex = numvertices++;
          vertexmap[vertextag] = vertexindex;
          vertices.push(v);
        } else {
          vertexindex = vertexmap[vertextag];
        }

        sideVertexIndices[sidevertexindicesindex++] = vertexindex;
      });
    });
    var vertexData = new Float64Array(numvertices * 2);
    var verticesArrayIndex = 0;
    vertices.map(function (v) {
      var pos = v.pos;
      vertexData[verticesArrayIndex++] = pos._x;
      vertexData[verticesArrayIndex++] = pos._y;
    });
    var result = {
      'class': 'CAG',
      sideVertexIndices: sideVertexIndices,
      vertexData: vertexData
    };
    return result;
  }
};
module.exports = CAG;